"use client"

import * as React from "react"
import * as TooltipPrimitive from "@radix-ui/react-tooltip"
import { twMerge } from "tailwind-merge"

const TooltipProvider = ({
	delayDuration = 0,
	...props
}: React.ComponentProps<typeof TooltipPrimitive.Provider>) => {
	return (
		<TooltipPrimitive.Provider
			delayDuration={delayDuration}
			{...props}
		/>
	)
}

const Tooltip = (
	props: React.ComponentProps<typeof TooltipPrimitive.Root>
) => {
	return (
		<TooltipPrimitive.Root
			data-slot="tooltip"
			{...props}
		/>
	)
}

const TooltipTrigger = (
	props: React.ComponentProps<typeof TooltipPrimitive.Trigger>
) => {
	return (
		<TooltipPrimitive.Trigger
			data-slot="tooltip-trigger"
			{...props}
		/>
	)
}

const TooltipContent = ({
	className,
	sideOffset = 4,
	hideArrow = false,
	children,
	...props
}: React.ComponentProps<typeof TooltipPrimitive.Content> & {
	hideArrow?: boolean
}) => {
	return (
		<TooltipPrimitive.Portal>
			<TooltipPrimitive.Content
				data-slot="tooltip-content"
				sideOffset={sideOffset}
				className={twMerge(
					"z-50 overflow-hidden rounded-lg bg-gray-900 px-3 py-1.5 text-xs text-white",
					"animate-in fade-in-0 zoom-in-95",
					"data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95",
					"data-[side=bottom]:slide-in-from-top-2",
					"data-[side=top]:slide-in-from-bottom-2",
					"data-[side=left]:slide-in-from-right-2",
					"data-[side=right]:slide-in-from-left-2",
					className
				)}
				{...props}
			>
				{children}

				{!hideArrow ? (
					<TooltipPrimitive.Arrow
						className="fill-gray-900"
						width={8}
						height={4}
					/>
				) : null}
			</TooltipPrimitive.Content>
		</TooltipPrimitive.Portal>
	)
}

export {
	TooltipProvider,
	Tooltip,
	TooltipTrigger,
	TooltipContent,
}
